import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './BulkBar.module.css';

export type BulkBarProps = {
  label: string;
  countLabel: string;
  clearLabel: string;
  onClear: () => void;
  children: ReactNode;
};

export const BulkBar = ({ label, countLabel, clearLabel, onClear, children }: BulkBarProps) => (
  <div className={styles['bar']} role="region" aria-label={label}>
    <span className={styles['count']} role="status">
      {countLabel}
    </span>
    <div className={styles['actions']}>{children}</div>
    <button type="button" className={styles['clear']} aria-label={clearLabel} onClick={onClear}>
      <X size={18} aria-hidden="true" />
    </button>
  </div>
);
